import { useState } from "react";

import styled from "styled-components/macro";

import TierPriceEditor from "Payments/TierPricing/TierPriceEditor";
import { COST_TYPES } from "Signups/SharedComponents/costTypes";

import FnrButton from "UI/FnrButton3";
import FnrEnrichedCheckbox, {
  FnrCheckboxSubtext,
  FnrCheckboxText,
} from "UI/FnrEnrichedCheckbox";
import FnrFade from "UI/FnrFade";

import { Subtitle } from "../..";

export function Pricing({
  isSuggestedDonation,
  amounts,
  setAmounts,
  costType,
  setCostType,
  isLoading,
  saveNewSignup,
  entity,
  listTypeID,
}) {
  const [tierDataValid, setTierDataValid] = useState(true);
  const letsGoDisabled = !(
    costType === COST_TYPES.PER_SLOT ||
    (costType === COST_TYPES.PER_SIGNUP && tierDataValid)
  );

  return (
    <Wrapper>
      <Subtitle>
        {isSuggestedDonation
          ? "When asking for a donation, how would you like to prompt respondents to donate?"
          : "How would you like to charge respondents when they sign up?"}
      </Subtitle>

      <FnrEnrichedCheckbox
        on={costType === COST_TYPES.PER_SLOT}
        toggleOn={() => setCostType(COST_TYPES.PER_SLOT)}
        style={{ paddingLeft: 8 }}
        checkSide="left"
      >
        <FnrCheckboxText>
          {isSuggestedDonation ? "Ask" : "Charge"} per {entity}
        </FnrCheckboxText>
        <CheckboxSubtext>
          {`Each ${entity} someone signs up for will incur its own charge. You can change the prices for each ${entity} once you create the Signup.`}
        </CheckboxSubtext>
      </FnrEnrichedCheckbox>

      {listTypeID !== 4 && ( // don't show for polls
        <FnrEnrichedCheckbox
          on={costType === COST_TYPES.PER_SIGNUP}
          toggleOn={() => setCostType(COST_TYPES.PER_SIGNUP)}
          style={{ paddingLeft: 8 }}
          checkSide="left"
        >
          <FnrCheckboxText>
            {isSuggestedDonation ? "Ask" : "Charge"} per household
          </FnrCheckboxText>
          <CheckboxSubtext>
            {
              "A single household will be charged the same amount, regardless of how many people in it sign up."
            }
          </CheckboxSubtext>
        </FnrEnrichedCheckbox>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (letsGoDisabled) {
            return;
          }
          saveNewSignup();
        }}
      >
        <FnrFade show={costType === COST_TYPES.PER_SIGNUP}>
          <div style={{ marginLeft: "52px" }}>
            <TierPriceEditor
              tierData={amounts}
              setTierData={setAmounts}
              setTierDataValid={setTierDataValid}
              entity={entity}
            />
          </div>
        </FnrFade>

        <ButtonsHolder>
          <FnrButton disabled={letsGoDisabled} color="blue" loading={isLoading}>
            {"Let's Go"}
          </FnrButton>
        </ButtonsHolder>
      </form>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 24px;
`;
const ButtonsHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-bottom: 12px;
`;

const CheckboxSubtext = styled(FnrCheckboxSubtext)`
  font-weight: 400;
  color: #828c8d;
`;
